<tiime-dialog [isLoading]="isLoading()" (cancel)="cancel()">
  <span mat-dialog-title>Documents</span>
  <mat-dialog-content mat-dialog-content>
    <tiime-subheader>
      <div content>
        <app-document-category-select
          [documentCategories]="documentCategories$ | async"
          [documentCategoryControl]="documentCategoryFilter"
          [small]="true"
          [disableCreate]="true"
        ></app-document-category-select>
      </div>
      <div actions>
        <tiime-table-loader [isLoading]="storeIsLoading$ | async"></tiime-table-loader>
      </div>
    </tiime-subheader>
    <tiime-sticky-table-container [containerState]="storeContainerState$ | async">
      <div tiimeContainerHeader>
        <tiime-search-bar
          data-cy="documents-search"
          dark
          placeholder="Rechercher un document..."
          [debounceTime]="0"
          [disabled]="storeContainerState$ | async | map: mapToDisabledSearchBar"
          (search)="applyFilter($event)"
        ></tiime-search-bar>
        <div tiimeContainerHeaderRight>
          <tiime-paginator
            [range]="range$ | async"
            [disabled]="storeContainerState$ | async | map: mapToDisabledPaginator"
            (rangeEvent)="applyRange($event)"
          ></tiime-paginator>
          <app-refresh-button [disabled]="storeIsLoading$ | async" (refresh)="refreshList()"></app-refresh-button>
        </div>
      </div>
      @if (documents$ | async; as documents) {
        <app-documents-table
          tiimeContainerContent
          [displayedColumns]="displayedColumns"
          [containerState]="storeContainerState$ | async"
          [documents]="documents"
          (applySort)="applySort($event)"
          (openDocumentDialog)="selectDocument($event)"
        ></app-documents-table>
      }
      <tiime-empty-state tiimeContainerOnboard>
        <img illu src="assets/illu_404_grey.svg" alt="empty document" />
        <span label>Aucun Document</span>
      </tiime-empty-state>
    </tiime-sticky-table-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="button" tiime-button color="accent" raised large (click)="cancel()">Fermer</button>
  </mat-dialog-actions>
</tiime-dialog>
